import { observable } from "mobx";

export interface IModelObject {
  _deleting?: boolean;
}

export interface IIuguPagamento {
  id?: number;
  conta_id?: number;
  usuario_id?: number;
  url_fatura: string;
  order_id: string;
  invoice_id: string;
  forma_pagamento: string;
  status: string;
  total: number;
  inserted_at: Date;
  updated_at: Date;
}
export interface ILogCienciaNsu {
  chave?: string;
  cnpj: string;
  codigo: string;
  erro: string;
  id: string;
  inserted_at: string;
  razao_social: string;
}

export interface ILogFilter {
  categoria: string;
  cnpj: string;
}

export function newILogFilter(): ILogFilter {
  return {
    categoria: "",
    cnpj: "",
  };
}

export interface IFilter {
  tipo: string;
  empresa: IEmpresa | string;
  filtro: string;
  ids: string[];
  data1: string;
  data2: string;
  chave?: string
}

export interface ILogWebServiceRequest {
  empresa: string;
  pagina: string;
  data1: string;
  data2: string;
}

export interface IResultMemoria {
  _id?: number;
  chave: string;
  cnpj_destino: string;
  item: number;
}

export function newIFilter(): IFilter {
  return ({
    tipo: "",
    empresa: newEmpresa(),
    filtro: "",
    ids: [""],
    data1: "",
    data2: "",
  });
}

export interface ILog {
  id?: number;
  conta_id?: number;
  usuario_id?: number;
  acao: string;
  usuario: string;
  inserted_at: Date;
  updated_at: Date;
  email: string;
  cnpj?: string;
}

export interface IPisCofins {
  id?: number;
  descricao: string;
  codigo: string;
  irpj: boolean;
  csll: boolean;
  cofins: boolean;
  pis_pased: boolean;
  inss_cpp: boolean;
  icms: boolean;
  ipi: boolean;
  iss: boolean;
}

export interface ISolicitacoesSEFA {
  id?: number;
  conta_id?: number;
  protocolo: string;
  tipo: string;
  data: Date;
  data_inicial: Date;
  data_final: Date;
  status: string;
  arquivo: string;
}

export interface INfePrefeitura {
  id?: number;
  conta_id?: number;
  protocolo: string;
  tipo: string;
  data: Date;
  periodo_inicio: string;
  periodo_fim: string;
  status: string;
  arquivo: string;
}

export interface IStats {
  empresa_count: number;
  cert_count: number;
  cert_venc: number;
  nota_count: number;
  empresa_plano_count: number;
  empresa_plano_simples_count: number;
  empresa_plano_normal_count: number;
}

export interface INotificacaoErro {
  conta_id: number;
  celular: string;
  email: string;
  periodicidade: string;
  meio_comunicacao: string;
  tipo: string;
  dia: string;
  chat_id: string;
  empresas: any
}

export function newINotificacaoErro(): INotificacaoErro {
  return {
    conta_id: 0,
    celular: "",
    email: "",
    periodicidade: "",
    meio_comunicacao: "",
    tipo: "",
    dia: "",
    chat_id: "",
    empresas: []
  }
}

export interface IUsuario {
  id?: number;
  _id?: string;
  conta_id?: string;
  email?: string;
  senha?: string;
  confirma_senha?: string;
  nome_completo?: string;
  admin?: boolean;
  principal?: boolean;
  conta?: IConta;
  processar_senha?: boolean;
  permissao?: string[];
  token_adm?: string;
  niveis_acesso?: string[];
  filiais?: string[];
  version_update: string;
  contrato?: IContrato;
  termos_dec?: boolean;
  representante?: boolean;
}

export function newIUsuario(): IUsuario {
  return {
    id: 0,
    _id: "",
    conta_id: "",
    email: "",
    senha: "",
    confirma_senha: "",
    nome_completo: "",
    admin: false,
    principal: false,
    processar_senha: false,
    permissao: [],
    token_adm: "",
    niveis_acesso: [],
    filiais: [],
    version_update: "",
    conta: newIConta(),
    contrato: newIContrato(),
    representante: false,
  }
}

export interface IContrato {
  _id: string;
  conta_id: string;
  assinado: boolean;
}

export function newIContrato(): IContrato {
  return {
    _id: "",
    conta_id: "",
    assinado: false,
  }
}

export interface IEmpresaRetroativa {
  cnpj_destino: string;
  inserted_at: string;
  chave: string[];
  conta_id: string;
  razao_social: string;
}

export interface IEmpresaNotaDivergente {
  cnpj_destino: string;
  inserted_at: string;
  chave: string[];
  conta_id: string;
  razao_social: string;
}

export interface IEmpresaNotaManual {
  cnpj_destino: string;
  inserted_at: string;
  chave: string[];
  conta_id: string;
  razao_social: string;
}

export interface IEmpresaErrosSefaz {
  cnpj: string;
  inserted_at: string;
  chave: string[];
  conta_id: string;
  categoria: string;
  razao_social: string;
}

export interface IEmpresa extends IModelObject {
  dec_sefa_auto: boolean;
  _id?: string;
  id?: number;
  razao_social: string;
  contador_responsavel: string;
  nome_fantasia?: string;
  cnpj: string;
  inscricao_estadual?: string;
  regime_especial_icms_pa: boolean;
  simples_nacional: boolean;
  tipo_empresa: string;
  plano: any;
  has_notas_imported?: boolean;
  convenio_icms_100_97: boolean;
  medicamento_uso_veterinario: boolean;
  auto_pecas: boolean;
  filial: boolean;
  certificado: string;
  certificado_socio: string;
  senha_certificado: string;
  senha_certificado_socio: string;
  regime_importacao: string;
  cipher_id: string;
  cpf_sefa: string;
  senha_sefa: string;
  plano_id: number;
  lcp123: any;
  receitabruta: any;
  anexo: string;
  contains_file_pgdaz: boolean;
  faixa: string;
  lista_rbt12: string[];
  cod_acesso: string;
  cpf_responsavel: string;
  valor_calculado: number;
  valor_calculado_saida: number;
  ativo: boolean;
  perfil_fiscal: string;
  robo: boolean;
  receita_bruta: number;
  inscricao_municipal: string;
  senha_inscricao_municipal: string;
  email: string;
  telefone: number;
  codigo_seguranca: string;
  municipio: string;
  uf: string;
  simples_nacional_excesso: boolean;
  porta_a_porta: boolean;
  calcula_nota_retroativa: boolean;
  logradouro: string
  cep: string
  bairro: string
  cod_folha: string,
  apelido: string,
  sitfis_automatico: boolean
  manifestacao_automatica: boolean
  calculo_automatico_nivy: boolean
  manifestacao_automatica_nfse: boolean
  caixapostal_automatica: boolean
  ativa_empresa: boolean
  rewritexml: boolean
  dec_sefa: boolean
  token_cliente_dominio: string
  token_cliente_sci: string
  envio_automatico_dominio_api: boolean
  envio_automatico_sci_api: boolean
  pgdas_email: string
  send_pgdas: boolean
  send_das: boolean
  tributa_fixo_iss: boolean
  senha_parauapebas: string
  email_calculos: string
  sefa_new: boolean
  cfop_calculo_sped: boolean
  sped_valor_inicial_data: string
  sped_valor_inicial: string
  sefa_metodo_login: string;
  cpf_gov: string;
  senha_gov: string;
  calculo_automatico_nivy_entrada: boolean;
  calculo_automatico_nivy_saida: boolean;
  indicadorComparacao: boolean
  abertura: string
  nfe_fazenda_automatico: boolean
  download_via_manifestador: boolean
  autenticacao_ecac: string;
  autenticacao_sefa: string;
  send_parcelas: boolean;
  parcelamentos_email: string;
  cpf_socio: string;
  senha_socio: string;
  autenticacao_dei: string
}

export function newEmpresa(): IEmpresa {
  return observable({
    id: null,
    razao_social: "",
    nome_fantasia: "",
    contador_responsavel: "",
    cnpj: "",
    regime_especial_icms_pa: false,
    simples_nacional: false,
    tipo_empresa: "industrial",
    inscricao_estadual: "",
    inscricao_municipal: "",
    plano: null,
    has_notas_imported: false,
    convenio_icms_100_97: false,
    medicamento_uso_veterinario: false,
    auto_pecas: false,
    filial: false,
    senha_certificado: "",
    senha_certificado_socio: "",
    certificado: "",
    certificado_socio: "",
    regime_importacao: "CAIXA",
    cipher_id: "",
    cpf_sefa: "",
    senha_sefa: "",
    plano_id: null,
    lcp123: [],
    receitabruta: "",
    anexo: "",
    contains_file_pgdaz: false,
    faixa: "",
    lista_rbt12: [],
    cpf_responsavel: "",
    cod_acesso: "",
    valor_calculado: 0,
    valor_calculado_saida: 0,
    ativo: true,
    perfil_fiscal: "",
    robo: false,
    receita_bruta: 0,
    senha_inscricao_municipal: "",
    email: "",
    telefone: 0,
    codigo_seguranca: "",
    municipio: "",
    uf: "",
    simples_nacional_excesso: false,
    porta_a_porta: false,
    calcula_nota_retroativa: false,
    ativa_empresa: false,
    logradouro: "",
    cep: "",
    bairro: "",
    cod_folha: "",
    apelido: "",
    sitfis_automatico: false,
    manifestacao_automatica: false,
    calculo_automatico_nivy: false,
    manifestacao_automatica_nfse: false,
    caixapostal_automatica: false,
    rewritexml: true,
    dec_sefa: false,
    token_cliente_dominio: null,
    token_cliente_sci: null,
    envio_automatico_dominio_api: false,
    envio_automatico_sci_api: false,
    pgdas_email: "",
    send_pgdas: false,
    send_das: false,
    tributa_fixo_iss: false,
    senha_parauapebas: "",
    email_calculos: "",
    sefa_new: false,
    cfop_calculo_sped: false,
    dec_sefa_auto: false,
    sped_valor_inicial_data: "",
    sped_valor_inicial: "",
    sefa_metodo_login: "",
    cpf_gov: "",
    senha_gov: "",
    calculo_automatico_nivy_entrada: false,
    calculo_automatico_nivy_saida: false,
    indicadorComparacao: false,
    abertura: "",
    nfe_fazenda_automatico: false,
    download_via_manifestador: false,
    autenticacao_ecac: "0",
    autenticacao_sefa: "0",
    send_parcelas: false,
    parcelamentos_email: "",
    cpf_socio: "",
    senha_socio: "",
    autenticacao_dei: "0"
  });
}

export interface IEmpresaDeclaracoes extends IModelObject {
  operacao: string;
  numero_declaracao: number;
  data_transmissao: string;
  recibo: string;
  declaracao: string;
  numero_das: number;
  data_emissao: string;
  extrato: string;
  mes: number;
  ano: number;
  id: number;
}

export interface IFornecedor extends IModelObject {
  id?: number;
  nome: string;
  atividade_principal?: string;
  atividades_secundarias?: string;
  cnpj: string;
  cep?: string;
  logradouro?: string;
  uf?: string;
  bairro?: string;
  complemento?: string;
  numero?: string;
  municipio?: string;
  natureza_juridica?: string;
  porte?: string;
  tipo?: string;
  data_situacao?: string;
  telefone?: string;
  email?: string;
  situacao?: string;
  abertura?: string;
  fantasia?: string;
  sped_id?: number;
}

export interface INota extends IModelObject {
  chave: string;
  data: Date;
  cnpj_destino: string;
  cnpj_origem: string;
  uf_destino: string;
  uf_origem: string;
  numero: number;
  serie: number;
  valor: number;
  aliquota_icms_origem: number;
  aliquota_icms_dest: number;
  items: INotaItem[];
  inserted_at: Date;
}

export interface INotaItem extends IModelObject {
  numero: number;
  descricao: string;
  cest: string;
  ncm: string;
  data: string;
  valor: number;
  valor_ipi: number;
  valor_icms_st: number;
  valor_icms_sn: number;
  base_calc_icms_ant: number;
  valor_icms_ant: number;
  memoria_calculo: string;
  memoria_calculo_fcp: string;
  memoria_calculo_1139: string;
  valor_contestacao_icms: number;
  motivo_contestacao_icms: string;
  nota: INota;
  calc: ICalc;
  mva_usuario: number;
  data_contestacao: Date;
  ie?: string;
  _id: string;
  monofasico?: boolean;
  monofasico_msg?: string;
  calc_sugerido?: boolean;
  calc_sugerido_msg?: string;
  valor_fcp: number;
  contestacao_id?: string;
  sugerido_list?: any[]
  calc_id: string
  id: string
  mva?: number
  nota_id?: string
}

export interface INfseItem extends IModelObject {
  numero: number;
  descricao: string;
  cest: string;
  ncm: string;
  valor: number;
  valor_ipi: number;
  valor_icms_st: number;
  valor_icms_sn: number;
  base_calc_icms_ant: number;
  valor_icms_ant: number;
  memoria_calculo: string;
  memoria_calculo_fcp: string;
  memoria_calculo_1139: string;
  valor_contestacao_icms: number;
  motivo_contestacao_icms: string;
  nota: INota;
  calc: ICalc;
  mva_usuario: number;
  data_contestacao: Date;
  ie?: string;
  _id: string;
  monofasico?: boolean;
  monofasico_msg?: string;
  calc_sugerido?: boolean;
  calc_sugerido_msg?: string;
  valor_fcp: number;
  prestador: string;
  tomador: string;
  forma_tributacao: string
  issqn: number
  nnfe: string
  chave: string
  contestacao_id?: string;
}

export interface IFiltro {
  tipo: string;
  filtro: string;
  empresa: string;
  data1: string;
  data2: string;
}

export interface ICalc {
  id: number;
  _id: string;
  tipo_empresa: string;
  tabela_mva: string;
  valido_de: Date;
  valido_ate: Date;
  convenio_icms_100_97: boolean;
  nome: string;
  icms_classificacao_id: number;
  icms_classificacao: IIcmsClassificacao;
  simples_nacional: boolean;
  simples_nacional_excesso: boolean;
  regime_especial: boolean;
  produtos: string[];
  confaz: number;
  regra_produtos: string;
  bc_var: string;
  bc_var_1139: string;
  vars: ICalcVar[];
  bc_var_fcp: string;
  vars_fcp: ICalcVar[];
  cfops: string;
  csts: string;
  regime_e_sem_regime: boolean;
  prioridade: number;
  medicamento_uso_veterinario: boolean;
  auto_pecas: boolean;
  entrada: boolean;
  saida: boolean;
  nfe: boolean;
  nfce: boolean;
  cte: boolean;
  nfse: boolean;
  revenda_com_st: boolean;
  revenda_sem_st: boolean;
  revenda_exterior: boolean;
  venda_com_st: boolean;
  venda_sem_st: boolean;
  venda_exterior: boolean;
  transporte_com_st: boolean;
  transporte_sem_st: boolean;
  comunicacao_com_st: boolean;
  comunicacao_sem_st: boolean;
  transporte: boolean;
  comunicacao: boolean;
  pis_cofins: string;
  pis_pased: boolean;
  pis_pased_lancamento_oficio?: boolean;
  pis_pased_st?: boolean;
  pis_pased_tributacao_monofasica?: boolean;
  cofins: boolean;
  cofins_lancamento_oficio?: boolean;
  cofins_st?: boolean;
  cofins_tributacao_monofasica?: boolean;
  icms: boolean;
  icms_imunidade?: boolean;
  icms_lancamento_oficio?: boolean;
  icms_st?: boolean;
  icms_antecipacao_encerramento_tributacao?: boolean;
  icms_retencao_iss?: boolean;
  irpj?: boolean;
  irpj_lancamento_oficio?: boolean;
  irpj_imunidade?: boolean;
  csll?: boolean;
  csll_lancamento_oficio?: boolean;
  csll_imunidade?: boolean;
  cpp?: boolean;
  cpp_lancamento_oficio?: boolean;
  cpp_imunidade?: boolean;
  porta_a_porta: boolean;
  index?: number;
  aplica_12: boolean;
  aplica_importados: boolean;
  aplica_interno: boolean;
  recolhimento: any
  contas_id?: any
  venda_locacao_nao_exterior?: boolean;
  venda_locacao_exterior?: boolean;
  servicos_contabeis?: boolean;
  servicos_fator_outro_municipio?: boolean;
  servicos_fator_proprio_municipio?: boolean;
  servicos_fator_com_retencao?: boolean;
  servicos_nao_fator_outro_municipio?: boolean;
  servicos_nao_fator_proprio_municipio?: boolean;
  servicos_nao_fator_com_retencao?: boolean;
  servicos_anexo_IV_outro_municipio?: boolean;
  servicos_anexo_IV_proprio_municipio?: boolean;
  servicos_anexo_IV_com_retencao?: boolean;
  servicos_construcao_III_outro_municipio?: boolean;
  servicos_construcao_III_mesmo_municipio?: boolean;
  servicos_construcao_III_com_retencao_substituicao?: boolean;
  servicos_construcao_IV_outro_municipio?: boolean;
  servicos_construcao_IV_mesmo_municipio?: boolean;
  servicos_construcao_IV_com_retencao_substituicao?: boolean;
  transporte_coletivo_outro_municipio?: boolean;
  transporte_coletivo_mesmo_municipio?: boolean;
  transporte_coletivo_com_retencao_substituicao?: boolean;
  servicos_exterior_escritorios?: boolean;
  servicos_exterior_fator?: boolean;
  servicos_exterior_nao_fator?: boolean;
  servicos_exterior_anexo?: boolean;
  servicos_exterior_construcao_anexo_III?: boolean;
  servicos_exterior_construcao_anexo_IV?: boolean;
  atividades_ipi_iss_outro_municipio?: boolean;
  atividades_ipi_iss_mesmo_municipio?: boolean;
  atividades_ipi_iss_com_retencao_substituicao?: boolean;
  atividades_ipi_iss_exterior?: boolean;
  icms_isencao_reducao?: boolean;
  icms_isencao_reducao_cesta_basica?: boolean;
  pis_imunidade?: boolean;
  cofins_imunidade?: boolean;
  codigos_tributacao: string
  iss: boolean;
  iss_imunidade?: boolean;
  iss_lancamento_oficio?: boolean;
  iss_reducao?: boolean;
  iss_retencao_iss?: boolean;
  anexo: ISimplesTabela
  secao: ISimplesTabela
  tabela: ISimplesTabela
  ipi: boolean;
  ipi_imunidade?: boolean;
  ipi_lancamento_oficio?: boolean;
  ipi_st?: boolean;
  ipi_nao_obrigatorio?: boolean;
  cofins_nao_obrigatorio?: boolean;
  csll_nao_obrigatorio?: boolean;
  iss_nao_obrigatorio?: boolean;
  icms_nao_obrigatorio?: boolean;
  cpp_nao_obrigatorio?: boolean;
  irpj_nao_obrigatorio?: boolean;
  pis_nao_obrigatorio?: boolean;
  sem_servicos: boolean;
  devolucao: boolean;
  list_csts_origem: any
  list_cfops: any
  list_csts: any
  list_pis_cofins: any
  list_tribu_nacional: any
  varejista: boolean;
  empresa_cnpj?: any
  force_cest: boolean
  cfop_sped_estadual: string
  cfop_sped_interestadual: string
  base_calculo_sped?: boolean;
  cst_sped: string
  exclusivo: boolean
  force_cson: boolean
  force_cfop: boolean
  uso_consumo_estadual: boolean
  uso_consumo_interestadual: boolean
  ativo_imobilizado_estadual: boolean
  ativo_imobilizado_interestadual: boolean
  descritivo_calculo: string
  transferencia_mercadorias_interestadual: boolean
  transferencia_mercadorias_estadual: boolean
  remessa_conserto_interestadual: boolean
  remessa_conserto_estadual: boolean
  remessa_comodato_interestadual: boolean
  remessa_comodato_estadual: boolean
  combustivel_consumo_interestadual: boolean
  combustivel_consumo_estadual: boolean
  combustivel_revenda_interestadual: boolean
  combustivel_revenda_estadual: boolean
  compra_prestacao_servico_interestadual: boolean
  compra_prestacao_servico_estadual: boolean
  insumos_industrializacao_interestadual: boolean
  insumos_industrializacao_estadual: boolean
  baixa_estoque_interestadual: boolean
  baixa_estoque_estadual: boolean
  bonificacao_interestadual: boolean
  bonificacao_estadual: boolean
  retorno_mercadoria_interestadual: boolean
  retorno_mercadoria_estadual: boolean
  remessa_garantia_interestadual: boolean
  remessa_garantia_estadual: boolean
  remessa_entrega_futura_interestadual: boolean
  remessa_entrega_futura_estadual: boolean
  devolucao_venda_interestadual: boolean
  devolucao_venda_estadual: boolean
  outras_entradas_interestadual: boolean
  outras_entradas_estadual: boolean
  mercadorias_demonstracao_interestadual: boolean
  mercadorias_demonstracao_estadual: boolean
  mercadorias_consignacao_interestadual: boolean
  mercadorias_consignacao_estadual: boolean
}

export interface IRecolhimento {
  codigo_recolhimento: string;
  descricao: string;
  periodicidade: string;
  periodo_subsequente: string;
  forma_vencimento: string;
  codigo_sped_fiscal: string;
}

export function newIRecolhimento(): IRecolhimento {
  return {
    codigo_recolhimento: "",
    descricao: "",
    periodicidade: "",
    periodo_subsequente: "",
    forma_vencimento: "",
    codigo_sped_fiscal: "",
  };
}

export interface IImportErro {
  id?: number;
  arquivo: string;
  erro: string;
  mensagem: string;
  chave: string;
  status: string;
  empresa_id: number;
  cnpj_origem: string;
  cnpj_destino: string;
  inserted_at: Date;
  cipher_id: string;
  sitnfe?: string;
}
export function newIImportErro(): IImportErro {
  return {
    id: 0,
    arquivo: "",
    erro: "",
    mensagem: "",
    chave: "",
    status: "",
    empresa_id: 0,
    cnpj_origem: "",
    cnpj_destino: "",
    inserted_at: new Date(),
    cipher_id: "",
    sitnfe: "",
  };
}

export interface IImport {
  id?: number;
  _id?: string;
  erros: number;
  importados: number;
  contestados: number;
  total: number;
  importacao_erros: IImportErro[];
}

export function newIImport(): IImport {
  return {
    erros: 0,
    importados: 0,
    contestados: 0,
    total: 0,
    importacao_erros: [],
  };
}

export interface IErros {
  cnpj: string;
  contagem: number;
  razao_social: string;
  tipo: string;
}

export interface IImportacao {
  id?: number;
  conta_id: number;
  nome_conta: string;
  razao_social: string;
  erros: number;
  importados: number;
  total: number;
  inserted_at: Date;
  importacao_erros: IImportErro[];
}

export interface IHistoricoNotas {
  id?: number;
  _id?: string;
  conta_id: number;
  cnpj_origem: string;
  chave: string;
  digestvalue: string;
  dhemi: string;
  nsu: string;
  download: boolean;
  confirmado: boolean;
  desconhecido: boolean;
  ciencia: boolean;
  nao_realizado: boolean;
  valor: number;
  nome: string;
  nnf: string;
  sitnfe: string;
  inserted_at: Date;
  updated_at: Date;
  cnpj_dest: string;
  cipher_id: string;
  importacao_erros: IImportErro[];
  cnpj_destino: string;
  tipo: string;
  calc: string;
}

export interface IHistoricoSaidas {
  id?: number;
  conta_id: number;
  cnpj_origem: string;
  cnpj_destino: string;
  chave: string;
  descevento: string;
  temp_dhemi: string;
  dhemi: Date;
  download: boolean;
  valor: number;
  inserted_at: Date;
  updated_at: Date;
}

export interface IXMLs {
  id?: number;
  _id?: string;
  conta_id: number;
  cnpj_origem: string;
  cnpj_destino: string;
  tipo: string;
  chave: string;
  dhemi: Date;
  valor: number;
  inserted_at: Date;
  updated_at: Date;
}

export interface ISaida {
  id?: number;
  conta_id: number;
  cnpj_origem: string;
  cnpj_destino: string;
  chave: string;
  descevento: string;
  dhemi: string;
}

export interface IImportInfo {
  import: IImport;
  summary: IImportSummary;
}

export function newIImportInfo(): IImportInfo {
  return {
    import: newIImport(),
    summary: newIImportSummary(),
  };
}

export interface IImportSummary {
  id: number;
  items?: [string, string][];
  single?: [string, string, string];
}

export function newIImportSummary(): IImportSummary {
  return {
    id: 0,
  };
}

export interface IResultadoItem {
  _id?: string;
  id: string;
  nota_id: number;
  calc_id: string;
  ncm: string;
  cest: string;
  descricao: string;
  classificacao_id: number;
  classificacao: string;
  data: Date;
  num_item: number;
  chave_nota: string;
  serie_nota: number;
  num_nota: number;
  valor_produto: string;
  desc: string;
  base_calc_icms_ant: number;
  valor_icms_ant: string;
  valor_contestacao_icms: string;
  motivo_contestacao_icms: string;
  contestacao_calc_id: any;
  valor_icms_st: string;
  mva_usuario: number;
  data_original: Date;
  data_calculo: Date;
  data_contestacao: Date;
  _selected?: boolean;
  uf_origem: string;
  entrada_saida?: string;
  classificacao_nome: string;
  dhrecbto: Date;
  pis?: string;
  cofins?: string;
  modelo?: string;
  cfop?: string;
  aliq_icms: string
  devolucao: boolean
  cst?: string;
  classificacao_cliente_final: string
}

export interface IResultadoItemProdutos {
  id: string;
  _id: string;
  nota_id: number;
  calc_id: number;
  ncm: string;
  cest: string;
  descricao: string;
  classificacao_id: number;
  classificacao: string;
  data: Date;
  num_item: number;
  chave_nota: string;
  serie_nota: number;
  num_nota: number;
  valor_produto: string;
  desc: string;
  base_calc_icms_ant: number;
  valor_icms_ant: string;
  valor_contestacao_icms: string;
  motivo_contestacao_icms: string;
  contestacao_calc_id: any;
  valor_icms_st: string;
  mva_usuario: number;
  data_original: Date;
  data_calculo: Date;
  data_contestacao: Date;
  _selected?: boolean;
  uf_origem: string;
  entrada_saida?: string;
  classificacao_nome: string;
  dhrecbto: Date;
  produtos: IProdutos[];
  calcs: ICalc[];
  empresa: IEmpresa;
  chave: string;
  cnpj_destino: string;
  cnpj_origem: string;
  aliquota_icms_origem: number
  aliquota_icms_dest: number
}

export interface IProdutos {
  id?: string;
  descricao: string;
  cest: string;
  aliquota: string;
}

export function newIProdutos(): IProdutos {
  return {
    id: "",
    descricao: "",
    cest: "",
    aliquota: "",
  };
}

export interface IProdutoPage {
  descricao: string;
  cest: string;
  ncm: string;
  entrada: boolean;
  estado: string;
  valido_de: Date;
  valido_ate: Date;

}

export function newIProdutoPage(): IProdutoPage {
  return {
    descricao: "",
    cest: null,
    ncm: "",
    entrada: true,
    estado: "",
    valido_de: null,
    valido_ate: null
  };
}

export interface IContestacaoProduto {
  motivo: string;
  produto: IProdutos[] | IProdutos;
  nota_item_ids: string[];
  valor_contestado: number;
  contestacao_calc_id: number | string;
  entrada_saida: string;
  modelo: string;
  contestacao_data: Date,
  contestacao_calc_id_devolucao?: string
}

export interface IResultadoHistorico {
  id: number;
  conta_id: number;
  cnpj: string;
  chave: string;
  digestvalue: string;
  dhemi: string;
  nsu: string;
  download: boolean;
  confirmado: boolean;
  desconhecido: boolean;
  ciencia: boolean;
  nao_realizado: boolean;
  cipher_id: string;
  inserted_at: Date;
  _selected?: boolean;
}

export interface IMva {
  id?: string;
  produto_cest: string;
  produto_ncm: string;
  produto_desc?: string;
  valido_de: Date;
  valido_ate: Date;
  mva: number;
  isDirty: boolean;
  item: string;
  margem_industrial_4?: string;
  margem_industrial_7: string;
  margem_industrial_12: string;
  margem_industrial_19: string;

  margem_distribuidor_4?: string;
  margem_distribuidor_7: string;
  margem_distribuidor_12: string;
  margem_distribuidor_19: string;

  margem_industrial_original?: string;
  margem_distribuidor_original?: string;

  entrada?: boolean
}
export function newIMva(): IMva {
  return ({
    id: "",
    valido_de: null,
    valido_ate: null,
    mva: 0,
    isDirty: false,
    item: "",
    produto_cest: "",
    produto_ncm: "",
    produto_desc: "",
    margem_industrial_4: "",
    margem_industrial_7: "",
    margem_industrial_12: "",
    margem_industrial_19: "",
    margem_distribuidor_4: "",
    margem_distribuidor_7: "",
    margem_distribuidor_12: "",
    margem_distribuidor_19: "",
    margem_industrial_original: "",
    margem_distribuidor_original: "",
    entrada: true,
  });
}

export interface IPlanoUpdate {
  cnpj: string;
  plano: number;
  descricao_plano: string;
}

export function newUpdatePlano() {
  return (
    {
      cnpj: "",
      plano: 0,
      descricao_plano: "",
    }
  );
}

export interface IEan {
  id?: number;
  calc: ICalc;
  calc_id: number;
  prod: string;
  produto: string;
  ean: string;
  ean_trib: string;
  ncm: string;
  cest: string;
}

export interface IProduto {
  id?: string;
  _id?: string;
  descricao: string;
  cest: string;
  ncm: string;
  aliquota_interna: number;
  aliquota_interna_regime?: number;
  mvas?: IMva[];
  model?: any;
  entrada: boolean;
  estado: string;
  valido_de: Date;
  valido_ate: Date;
}

export interface ILegisWebSimples {
  _id?: string;
  id?: string;
  ncm: string;
  descricao: string;
  atacadista: ILegisResposta;
  varejista: ILegisResposta;
  fabricante: ILegisResposta;
}

export interface ILegisResposta {
  resposta: any[];
  registro: number;
}

export interface ICnae {
  _id?: string;
  cnae: string;
  atividade: string;
  descricao: string;
  classe: ICnaeDetalhes[];
}
export function newICnae(): ICnae {
  return ({
    _id: "",
    cnae: "",
    atividade: "",
    descricao: "",
    classe: [],
  });
}
export interface ICnaeDetalhes {
  id: string;
  descricao?: string;
  grupo: string[];
  observacoes: string[];
}

export interface IContador {
  id?: string;
  nome: string;
  email: string;
  cpf: string;
  crc: string;
  cep: string;
  endereco: IEndereco;
}

export function newIContador(): IContador {
  return observable({
    id: "",
    nome: "",
    email: "",
    cpf: "",
    crc: "",
    cep: "",
    endereco: newIEndereco(),
  });
}

export interface IEndereco {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

export function newIEndereco(): IEndereco {
  return observable({
    cep: "",
    logradouro: "",
    complemento: "",
    bairro: "",
    localidade: "",
    uf: "",
    ibge: "",
    gia: "",
    ddd: "",
    siafi: "",
  });
}

export interface ICFOP {
  id?: any;
  descricao: string;
  codigo: string;
}

export function newCalc(): ICalc {
  return observable({
    id: null,
    _id: "",
    icms_classificacao_id: null,
    icms_classificacao: null,
    nome: "",
    simples_nacional: false,
    simples_nacional_excesso: false,
    regime_especial: false,
    tipo_empresa: null,
    produtos: [],
    confaz: 0,
    vars: [],
    vars_fcp: [],
    tabela_mva: null,
    bc_var: "BC",
    bc_var_1139: "BC",
    bc_var_fcp: "BC",
    regra_produtos: "inclusivo",
    cfops: "",
    csts: "",
    regime_e_sem_regime: false,
    prioridade: 50,
    valido_de: null,
    valido_ate: null,
    convenio_icms_100_97: false,
    medicamento_uso_veterinario: false,
    auto_pecas: false,
    entrada: false,
    saida: false,
    revenda_com_st: false,
    revenda_sem_st: false,
    revenda_exterior: false,
    venda_com_st: false,
    venda_sem_st: false,
    venda_exterior: false,
    transporte_com_st: false,
    transporte_sem_st: false,
    comunicacao_com_st: false,
    comunicacao_sem_st: false,
    transporte: false,
    comunicacao: false,
    nfe: false,
    nfce: false,
    cte: false,
    nfse: false,
    pis_cofins: "",
    pis_pased: false,
    cofins: false,
    icms: false,
    pis_pased_lancamento_oficio: false,
    pis_pased_st: false,
    pis_pased_tributacao_monofasica: false,
    cofins_lancamento_oficio: false,
    cofins_st: false,
    cofins_tributacao_monofasica: false,
    icms_imunidade: false,
    icms_lancamento_oficio: false,
    icms_st: false,
    icms_antecipacao_encerramento_tributacao: false,
    irpj: false,
    irpj_lancamento_oficio: false,
    csll: false,
    csll_lancamento_oficio: false,
    cpp: false,
    cpp_lancamento_oficio: false,
    porta_a_porta: false,
    aplica_12: false,
    aplica_importados: false,
    aplica_interno: false,
    icms_isencao_reducao: false,
    icms_isencao_reducao_cesta_basica: false,
    pis_imunidade: false,
    cofins_imunidade: false,
    recolhimento: {
      codigo_recolhimento: "",
      descricao: "",
      periodicidade: "",
      periodo_subsequente: "",
      forma_vencimento: "",
      codigo_sped_fiscal: "",
    },
    codigos_tributacao: "",
    iss: false,
    anexo: newISimplesTabela(),
    secao: newISimplesTabela(),
    tabela: newISimplesTabela(),
    ipi: false,
    sem_servicos: false,
    devolucao: false,
    list_csts_origem: [],
    list_cfops: [],
    list_csts: [],
    list_pis_cofins: [],
    list_tribu_nacional: [],
    force_cest: false,
    varejista: false,
    cfop_sped_estadual: "",
    cfop_sped_interestadual: "",
    base_calculo_sped: false,
    cst_sped: "",
    exclusivo: false,
    force_cson: false,
    force_cfop: false,
    uso_consumo_estadual: false,
    uso_consumo_interestadual: false,
    ativo_imobilizado_estadual: false,
    ativo_imobilizado_interestadual: false,
    descritivo_calculo: "",
    transferencia_mercadorias_interestadual: false,
    transferencia_mercadorias_estadual: false,
    remessa_conserto_interestadual: false,
    remessa_conserto_estadual: false,
    remessa_comodato_interestadual: false,
    remessa_comodato_estadual: false,
    combustivel_consumo_interestadual: false,
    combustivel_consumo_estadual: false,
    combustivel_revenda_interestadual: false,
    combustivel_revenda_estadual: false,
    compra_prestacao_servico_interestadual: false,
    compra_prestacao_servico_estadual: false,
    insumos_industrializacao_interestadual: false,
    insumos_industrializacao_estadual: false,
    baixa_estoque_interestadual: false,
    baixa_estoque_estadual: false,
    bonificacao_interestadual: false,
    bonificacao_estadual: false,
    retorno_mercadoria_interestadual: false,
    retorno_mercadoria_estadual: false,
    remessa_garantia_interestadual: false,
    remessa_garantia_estadual: false,
    remessa_entrega_futura_interestadual: false,
    remessa_entrega_futura_estadual: false,
    devolucao_venda_interestadual: false,
    devolucao_venda_estadual: false,
    outras_entradas_interestadual: false,
    outras_entradas_estadual: false,
    mercadorias_demonstracao_interestadual: false,
    mercadorias_demonstracao_estadual: false,
    mercadorias_consignacao_interestadual: false,
    mercadorias_consignacao_estadual: false
  })
}

export interface ICalcVar {
  id: number;
  expr: string;
  nome: string;
  descricao: string;
  order: number;
  entrada: boolean;
  saida: boolean;
  is1139?: boolean;
}

export interface INotaVar {
  id?: number;
  _id?: string;
  nome: string;
  descricao?: string;
  campo: string;
}

export interface IContestacao {
  nota_item_ids: string[];
  valor_contestado: number;
  contestacao_calc_id: any;
  contestacao_data: Date;
  motivo: string;
  mva: number;
  contestacao_calc_id_devolucao?: string
}

export interface IContestacaoLote {
  nota_item_ids: string[];
  contestacao_calc_id: any;
  contestacao_data: Date;
  motivo: string;
  entrada_saida: string;
  modelo: string;
  contestacao_calc_id_devolucao?: string
  contestacao_produto_id?: string
}

export interface IContestacaoLoteCalculados {
  nota_item_ids: string[];
  contestacao_calc_id: any;
  contestacao_data: Date;
  motivo: string;
  entrada_saida: string;
  modelo: string;
  produto: any;
  contestacao_calc_id_devolucao?: string
}

export interface IIcmsClassificacao {
  id?: number;
  codigo_receita?: string;
  dae_avulso?: boolean;
  nome: string;
  dei?: boolean;
}

export interface ITransmissao {
  id?: number;
  receita_bruta_interno: number;
  receita_bruta_externo: number;
  periodo_apuracao: string;
  mes: number;
  ano: number;
  declaracoes: ITransmissaoDeclaracao;
  status: number;
}

export interface ITransmissaoDeclaracao {
  ano: number;
  data_transmissao: string;
  data_emissao: string;
  status: number;
  data_das: string;
  recibo: string;
  declaracao: string;
  extrato: string;
  numero_das: number;
  das: string;
  numero_declaracao: string;
}

export function newITransmissao(mes: number): ITransmissao {
  return observable({
    id: 0,
    receita_bruta_interno: 0,
    receita_bruta_externo: 0,
    periodo_apuracao: "",
    mes: mes,
    ano: 0,
    declaracoes: newITransmissaoDeclaracao(),
    status: 0,
  });
}

export function newITransmissaoDeclaracao(): ITransmissaoDeclaracao {
  return observable({
    ano: 0,
    data_transmissao: "",
    data_emissao: "",
    status: 0,
    data_das: "",
    recibo: "",
    declaracao: "",
    extrato: "",
    das: "",
    numero_das: 0,
    numero_declaracao: "",
  });
}

export interface IResultadoSummary {
  icms_classificacao_id: number;
  valor: number;
  valor_icms: number;
  valor_1139: number;
  valor_fcp: number;
  valor_icms_st: number;
  valor_contestacao_icms: number;
  classificacao?: string;
  dae?: boolean;
  dei?: boolean;
  codigo_receita?: string;
}

export interface IConta {
  _id?: number;
  id?: number;
  nome?: string;
  cnpj?: string;
  saldo?: number;
  rua?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  estado?: string;
  cep?: string;
  ddd?: string;
  telefone?: string;
  imagem?: string;
  ativo: boolean;
  qtd_cnpj_normal?: number;
  qtd_cnpj_simples?: number;
  qtd_cnpj_normal_em_uso?: number;
  qtd_cnpj_simples_em_uso?: number;
  _selected?: boolean;
  status_pagamento: string;
  usuarios: IUsuario[];
  autenticacao: string;
  notificacao: boolean;
  inserted_at?: Date;
  teste?: boolean;
  robo?: boolean;
  teste_rapido?: boolean;
  fatura_ativacao?: string;
  forma_pagamento?: string;
  id_assinatura?: string;
  desconto?: number;
  iugu_fatura?: any;
  sefip?: boolean;
  certificado?: string;
  senha_certificado?: string;
  bot_prefeitura?: boolean;
  libera_pagamento?: boolean;
  libera_contrato?: boolean;
  razao_social?: string;
  iugu_pagamento?: any;
  acomar?: boolean;
  sefa_new?: boolean;
  dae_new?: boolean;
  dec_sefa_new?: boolean;
}

export function newIConta(): IConta {
  return {
    ativo: true,
    status_pagamento: "",
    usuarios: [],
    autenticacao: "",
    notificacao: false,
    teste: false,
    sefa_new: false,
    dae_new: false
  }
}

export interface IAssinatura {
  cod_plano?: string;
  descricao?: string;
  status: string;
  pagseguro_id?: string;
  pagseguro_sender_hash?: string;
  valor?: number;
  proxima_cobranca?: Date;
  ultima_cobranca?: Date;
  periodicidade?: string;
  parcelas?: number;
  proxima_parcela?: number;
  cartao_final?: string;
  cartao_exp_mes?: number;
  cartao_exp_ano?: number;
  pagseguro_status?: string;
  token_cartao?: string;
  inserted_at?: Date;
}

export interface ISefipTransmissao extends ISefip {
  arquivo: string;
  fap: string;
  fgts: string;
  // inss: string
}

export interface ISefip {
  tipo_folha: string;
  cod_folha: string;
  competencia: string;
  empresa_recolhimento?: string;
  municipio_recolhimento?: string;
  // cnpj: string
  // razao_social: string
  cpf?: string;
  nome?: string;
  reajuste_salarial?: boolean
}

export interface IRequest {
  data: string;
}

export interface IMunicipio {
  nome: string;
  estado: string;
  id: string;
}

export function newIMunicipio(): IMunicipio {
  return ({
    nome: "",
    id: "",
    estado: ""
  });
}

export interface IProdutoGenerico {
  descricao: string;
  id: string;
  _id: string;
  cest: string,
  ncm: string,
  gtin: string,
  cnpj: string,
  unidade: string,
  produtos?: any
}

export function newIProdutoGenerico(): IProdutoGenerico {
  return ({
    descricao: "",
    _id: "",
    id: "",
    cest: "",
    ncm: "",
    gtin: "",
    cnpj: "",
    unidade: "",
    produtos: [],
  });
}

export interface IMemoriaCalculo {
  _id: string;
  ncm: string;
  calc_nome: string;
  cnpj_destino: string;
  cnpj_origem: string;
  inserted_at: string;
  _insertedTS: string;
  cest: string;
  descricao?: string;

  cfop?: string;
  cst?: string;
  pis?: string;
  cofins?: string;
  calc_id: string;
  mva: string;
  cnpj_memoria: boolean
}

export interface ISefipTransmissaoRecalc {
  arquivo: string[];
  competencia: string;
  competencia_atraso: Date;
  pis: IPis[];
  empresa_recalc?: string;
  cpf_recalc?: string;
  nome_recalc?: string;
  municipio_recalc?: string;
}

export function newISefipTransmissaoRecalc(): ISefipTransmissaoRecalc {
  return ({
    arquivo: [""],
    competencia_atraso: new Date(),
    competencia: "",
    pis: [],
    empresa_recalc: "",
    nome_recalc: "",
    cpf_recalc: "",
    municipio_recalc: "",
  });
}

export interface IPis {
  pis: string;
  id: string;
}

export interface ILogSefip {
  id?: string;
  tipo: string;
  nome: string;
  cpf: string;
  cnpj: string;
  status: string;
  prioridade: string;
  finalizado: boolean;
  data_criacao: string;
  ultima_atualizacao: string;
  competencia: string;
  cod_folha: number;
  tipo_folha: string;
  erros: string[];
  arquivos: ISefipArquivos[];
  uuid: string;
}

export function newILogSefip(): ILogSefip {
  return ({
    tipo: "",
    nome: "",
    cpf: "",
    cnpj: "",
    status: "",
    prioridade: "",
    finalizado: false,
    data_criacao: "",
    ultima_atualizacao: "",
    competencia: "",
    cod_folha: 0,
    tipo_folha: "",
    erros: [""],
    arquivos: [{
      id: 0,
      nome: "",
      download: "",
    }],
    uuid: "",
  });
}
export interface ILogSefa {
  id?: string;
  tipo: string;
  nome: string;
  cpf: number;
  empresa: string;
  status: string;
  prioridade: string;
  finalizado: boolean;
  data_criacao: string;
  ultima_atualizacao: string;
  competencia: string;
  cod_folha: number;
  tipo_folha: string;
  erro: string;
  log_erros: string[];
  arquivos: any[];
  uuid: string;
  sefa_new: boolean;
  data_agendamento: string;
}

export function newILogSefa(): ILogSefa {
  return ({
    tipo: "",
    nome: "",
    cpf: 0,
    status: "",
    empresa: "",
    prioridade: "",
    finalizado: false,
    data_criacao: "",
    ultima_atualizacao: "",
    competencia: "",
    cod_folha: 0,
    tipo_folha: "",
    erro: "",
    log_erros: [""],
    arquivos: [{
      id: 0,
      nome: "",
      download: "",
    }],
    uuid: "",
    sefa_new: false,
    data_agendamento: "",
  });
}
export interface ISefipArquivos {
  id: number;
  nome: string;
  download: string;
}

export interface ISefaArquivos {
  id: number;
  nome: string;
  download: string;
}

export interface ILegisWebLucro {
  _id?: string;
  ncm: string;
  descricao: string;
  atacadista: ILegisResposta;
  distribuidor: ILegisResposta;
  varejista: ILegisResposta;
  fabricante: ILegisResposta;
}

export interface ISped {
  id?: string;
  data_inicio: string;
  data_fim: string;
  cnpj_emissor: string;
}

export interface ILogSped {
  id?: string;
  tipo: string;
  empresa: string;
  status: string;
  finalizado: boolean;
  data_criacao: string;
  ultima_atualizacao: string;
  competencia: string;
  cod_folha: number;
  tipo_folha: string;
  arquivos: ISefipArquivos[];
  uuid: string;
}

export function newILogSped(): ILogSped {
  return ({
    tipo: "",
    empresa: "",
    status: "",
    finalizado: false,
    data_criacao: "",
    ultima_atualizacao: "",
    competencia: "",
    cod_folha: 0,
    tipo_folha: "",
    arquivos: [{
      id: 0,
      nome: "",
      download: "",
    }],
    uuid: "",
  });
}

export interface ILogSpedArquivos {
  id: number;
  nome: string;
  download: string;
}

export interface ISpedTabelas {
  id: number;
  _id: number;
  codigo: string;
  layout?: string;
  versao?: string;
  descricao: string;
  data_inicio: string;
  data_fim: string;
  credito?: boolean
}

export interface IPrefeituraErro {
  id?: number;
  cnpj: string;
  razao_social: string;
  erros: string[];
}

export interface IPrefeituraDetalhes {
  id?: string;
  arquivos: string[];
  dados: string[];
  // erros: string[],
  pessoa: string[];
  status: string;
  ultima_atualizacao: string;
  solicitacao_id: string
}

export interface ILogPgdas {
  id?: string;
  _id?: string;
  tipo: string;
  nome: string;
  cpf: number;
  status: string;
  prioridade: string;
  finalizado: boolean;
  data_criacao: string;
  ultima_atualizacao: string;
  competencia: string;
  cod_folha: number;
  tipo_folha: string;
  erros: string[];
  arquivos: ISefipArquivos[];
  uuid: string;
}

export function newILogPgdas(): ILogPgdas {
  return ({
    tipo: "",
    nome: "",
    cpf: 0,
    status: "",
    prioridade: "",
    finalizado: false,
    data_criacao: "",
    ultima_atualizacao: "",
    competencia: "",
    cod_folha: 0,
    tipo_folha: "",
    erros: [""],
    arquivos: [{
      id: 0,
      nome: "",
      download: "",
    }],
    uuid: "",
  });
}
export interface ILogPgdasArquivos {
  id: number;
  nome: string;
  download: string;
}
export interface ITipi {
  id: string;
  ncm: string;
  descricao: string;
}
export function newITipi(): ITipi {
  return ({
    id: "",
    ncm: "",
    descricao: "",
  });
}

export interface IContestacaoCalc {
  id: string;
  data: Date;
}

export interface IContestacaoCalcCalculados {
  id: string;
  data: Date;
  produtos: IProduto
}

export interface IContratoUser {
  id: string;
  cnpj: string;
  rua: string;
  numero: string
  bairro: string;
  cidade: string;
  cep: string;
  estado: string;
  nome: string;
  nome_pessoa: string;
  cpf_pessoa: string;
  rua_pessoa: string;
  bairro_pessoa: string;
  cidade_pessoa: string;
  cep_pessoa: string;
  numero_pessoa: string;
  estado_pessoa: string;
}

export function newIContratoUser(): IContratoUser {
  return {
    id: "",
    cnpj: "",
    rua: "",
    numero: "",
    bairro: "",
    cidade: "",
    cep: "",
    estado: "",
    nome: "",
    nome_pessoa: "",
    cpf_pessoa: "",
    rua_pessoa: "",
    bairro_pessoa: "",
    cidade_pessoa: "",
    cep_pessoa: "",
    numero_pessoa: "",
    estado_pessoa: "",
  }
}
export interface IResultadoItemNFSE {
  _id: string
  conta_id: string
  forma_tributacao: string
  inserted_at: Date
  data: Date
  data_calculo: Date
  isssqn: string
  nnfe: string
  nome: string
  valor: number
  descricao: string
  valor_deducoes: number
  valor_pis: number
  valor_cofins: number
  valor_iss: number
  valor_ir: number
  valor_csll: number
  valor_inss: number
  cod_trib_nacional: string
  chave: string
  competencia: string
}

export interface ILogPrefeitura {
  id?: string;
  razao_social: string;
  cnpj: string;
  date_start: string;
  erros: string[];
}

export function newILogPrefeitura(): ILogPrefeitura {
  return ({
    razao_social: "",
    cnpj: "",
    date_start: "",
    erros: [""],
  });
}

export interface IMvaRS {
  mva_positiva: string
  mva_neutra: string
  mva_negativa: string
  mva_ajustada_4: string
  mva_ajustada_7: string
  mva_ajustada_12: string
  mva_ajustada: string
  mva: string
  aliquota_interna: string
}
export function newIMvaRS(): IMvaRS {
  return ({
    mva_positiva: "",
    mva_neutra: "",
    mva_negativa: "",
    mva_ajustada_4: "",
    mva_ajustada_7: "",
    mva_ajustada_12: "",
    mva_ajustada: "",
    mva: "",
    aliquota_interna: ""
  });
}
export interface ISpedEfd {
  id?: string;
  cnpj: string;
  import_notas: boolean;
  gerar_informacoes: boolean;
  informacoes_conforme: string
  deduzir_icms: boolean;
  icms_config: boolean;
  cst_icms_config: boolean;
  cfop_icms_config: boolean;
}

export function newISpedEfd(): ISpedEfd {
  return ({
    cnpj: "",
    import_notas: false,
    gerar_informacoes: false,
    informacoes_conforme: "nota",
    deduzir_icms: false,
    icms_config: false,
    cst_icms_config: false,
    cfop_icms_config: false
  });
}

export interface ISaidaCFOP {
  id?: string;
  config_id?: string;
  cfops_entrada: any;
  cfop_saida: any;
  cst_entrada: string;
  csts_selecionados: any;
}

export interface IEntradaCFOP {
  id?: string;
  config_id?: string;
  cfop_entrada: any;
  cfops_saida: any;
  cst_saida: string;
  csts_selecionados: any;
}

export function newISaidaCFOP(): ISaidaCFOP {
  return ({
    cfop_saida: "",
    cfops_entrada: [],
    cst_entrada: "todos",
    csts_selecionados: [],
  });
}

export function newIEntradaCFOP(): IEntradaCFOP {
  return ({
    cfop_entrada: "",
    cfops_saida: [],
    cst_saida: "todos",
    csts_selecionados: [],
  });
}

export interface IManifestacaoCalc {
  id: string;
}

export interface IIcmsAliquota {
  id?: string;
  origem_uf: string;
  destino_uf: string;
  aliquota_pct: string;
  valido_de?: Date;
  valido_ate?: Date;
}
export function newIIcmsAliquota(): IIcmsAliquota {
  return ({
    id: "",
    origem_uf: "",
    destino_uf: "",
    aliquota_pct: "",
    valido_de: new Date(),
    valido_ate: new Date(),
  });
}

export interface IPautaRS {
  id?: string;
  gtin: string;
  descricao: string;
  multiplo: string;
  pmpf: string;
}
export function newIPautaRS(): IPautaRS {
  return ({
    id: "",
    gtin: "",
    descricao: "",
    multiplo: "",
    pmpf: "",
  })
}
export interface ICstSped {
  cod: string;
  descricao: string;
  vinculado?: string
}

export function newICstSped(): ICstSped {
  return ({
    descricao: "",
    cod: "",
  });
}

export interface ICstConfigSped {
  _id?: string;
  ipi: ICstSped[]
  pis: ICstSped[]
  cofins: ICstSped[]
  config_id: string
  ignorar_ipi: boolean
  ignorar_pis: boolean
  ignorar_cofins: boolean
}

export function newICstConfigSped(): ICstConfigSped {
  return ({
    ipi: [],
    pis: [],
    cofins: [],
    config_id: "",
    ignorar_ipi: true,
    ignorar_pis: true,
    ignorar_cofins: true
  });
}

export interface DashboardGraph {
  totalJaneiro: number;
  totalFevereiro: number;
  totalMarco: number;
  totalAbril: number;
  totalMaio: number;
  totalJunho: number;
  totalJulho: number;
  totalAgosto: number;
  totalSetembro: number;
  totalOutubro: number;
  totalNovembro: number;
  totalDezembro: number;
  totalErroJaneiro: number;
  totalErroFevereiro: number;
  totalErroMarco: number;
  totalErroAbril: number;
  totalErroMaio: number;
  totalErroJunho: number;
  totalErroJulho: number;
  totalErroAgosto: number;
  totalErroSetembro: number;
  totalErroOutubro: number;
  totalErroNovembro: number;
  totalErroDezembro: number;
}

export function newDashboardGraph(): DashboardGraph {
  return ({
    totalJaneiro: 0,
    totalFevereiro: 0,
    totalMarco: 0,
    totalAbril: 0,
    totalMaio: 0,
    totalJunho: 0,
    totalJulho: 0,
    totalAgosto: 0,
    totalSetembro: 0,
    totalOutubro: 0,
    totalNovembro: 0,
    totalDezembro: 0,
    totalErroJaneiro: 0,
    totalErroFevereiro: 0,
    totalErroMarco: 0,
    totalErroAbril: 0,
    totalErroMaio: 0,
    totalErroJunho: 0,
    totalErroJulho: 0,
    totalErroAgosto: 0,
    totalErroSetembro: 0,
    totalErroOutubro: 0,
    totalErroNovembro: 0,
    totalErroDezembro: 0
  });
}

export interface ITags extends IModelObject {
  _id?: string;
  id?: string;
  name: string;
  xml: string;
  tag: string;
  value: string
}

export function newITags(): ITags {
  return ({
    name: "",
    xml: "",
    tag: "",
    value: ""
  });
}

export interface IRelatorios extends IModelObject {
  id?: string;
  nome: string;
  modelo: string;
  columns: any;
  filtro: any;
  treeData: any;
}

export function newIRelatorios(): IRelatorios {
  return ({
    nome: "",
    modelo: "",
    columns: [],
    filtro: [],
    treeData: []
  });
}

export interface IReceita {
  codigo_receita: string
  valor_pagar: number
  data_referencia: string
  data_calculo: string
  documento_origem: string
  data_vencimento: string
  informacao_adicional: string
  cnpj: string
}

export function newIReceita(): IReceita {
  return ({
    codigo_receita: "",
    valor_pagar: 0,
    data_referencia: "",
    data_calculo: "",
    data_vencimento: "",
    documento_origem: "",
    informacao_adicional: "",
    cnpj: ""
  });
}

export interface ISaidaEspecificoCFOP {
  cfops_entrada: any;
}

export interface IEntradaEspecificoCFOP {
  cfops_saida: any;
}

export function newISaidaEspecificoCFOP(): ISaidaEspecificoCFOP {
  return ({
    cfops_entrada: [],
  });
}

export function newIEntradaEspecificoCFOP(): IEntradaEspecificoCFOP {
  return ({
    cfops_saida: [],
  });
}

export interface IAgendamento {
  listEmpresas: any;
  periodo_selecionado: string;
  dia: string;
  descricao: string;
  recorrente: boolean;
  id: string;
  data_solicitacao: Date
  periodoNotas: string
  periodoAno: string
  gratuito: boolean;
}

export function newIAgendamento(): IAgendamento {
  return observable({
    listEmpresas: [],
    periodo_selecionado: "",
    dia: "",
    descricao: "",
    recorrente: false,
    id: "",
    data_solicitacao: null,
    periodoNotas: "",
    periodoAno: "",
    gratuito: false,
  });
}

export interface ISimplesTabela {
  cod: string;
  descricao: string;
}

export function newISimplesTabela(): ISimplesTabela {
  return ({
    descricao: "",
    cod: "",
  });
}

export interface IResultadosFilters {
  filterCest: string,
  filterNcm: string,
  filterDescricao: string,
  filterNumero: string,
  filterCfop: string,
  filterChave: string,
  filterCstCson: string,
  filterPis: string,
  filterCofins: string
}

export function newIResultadosFilters(): IResultadosFilters {
  return ({
    filterCest: "",
    filterNcm: "",
    filterDescricao: "",
    filterNumero: "",
    filterCfop: "",
    filterChave: "",
    filterCstCson: "",
    filterPis: "",
    filterCofins: ""
  });
}

export interface IMonofasicoSimples {
  id?: string;
  descricao: string;
  legislacao: string;
  item: string;
  ncm: string;
  valido_de: Date;
  valido_ate: Date;
}
export function newIMonofasicoSimples(): IMonofasicoSimples {
  return ({
    id: "",
    descricao: "",
    legislacao: "",
    item: "",
    ncm: "",
    valido_de: null,
    valido_ate: null,
  });
}

export interface ISomaNotas {
  entrada_1: number
  saida_1: number
  entrada_2: number
  saida_2: number
  entrada_3: number
  saida_3: number
  entrada_4: number
  saida_4: number
  entrada_5: number
  saida_5: number
  entrada_6: number
  saida_6: number
  entrada_7: number
  saida_7: number
  entrada_8: number
  saida_8: number
  entrada_9: number
  saida_9: number
  entrada_10: number
  saida_10: number
  entrada_11: number
  saida_11: number
  entrada_12: number
  saida_12: number
  total_12m: number

}

export function newISomaNotas(): ISomaNotas {
  return {
    entrada_1: 0,
    saida_1: 0,
    entrada_2: 0,
    saida_2: 0,
    entrada_3: 0,
    saida_3: 0,
    entrada_4: 0,
    saida_4: 0,
    entrada_5: 0,
    saida_5: 0,
    entrada_6: 0,
    saida_6: 0,
    entrada_7: 0,
    saida_7: 0,
    entrada_8: 0,
    saida_8: 0,
    entrada_9: 0,
    saida_9: 0,
    entrada_10: 0,
    saida_10: 0,
    entrada_11: 0,
    saida_11: 0,
    entrada_12: 0,
    saida_12: 0,
    total_12m: 0
  }
}

export interface IItem {
  id?: string;
  descricao: string;
  codigo: string;
}

export function newIItem(): IItem {
  return ({
    descricao: "",
    codigo: "",
  });
}


export interface IMemoria {
  id?: string
  estado: string
  modelo: string
  descricao: string
  cest: string
  cfop: string
  cofins: string
  cst: string
  ncm: string
  pis: string
  mva: number
  calc_id: string,
  cnpj_destino: string
  cnpj_origem: string
  cnpj_memoria: boolean
}

export function newIMemoria(): IMemoria {
  return ({
    estado: "",
    modelo: "",
    descricao: "",
    cest: "",
    cfop: "",
    cofins: "",
    cst: "",
    ncm: "",
    pis: "",
    mva: 0,
    calc_id: null,
    cnpj_destino: "",
    cnpj_origem: "",
    cnpj_memoria: true
  });
}

export interface IReceitaBruta {
  valor: number
  mes: number
  taxa?: number
  tipo?: number
}

export interface ISpedTabela {
  codigo: string;
  data_fim: string;
  data_inicio: string;
  descricao: string;
}

export function newISpedTabela(): ISpedTabela {
  return ({
    codigo: "",
    data_fim: "",
    data_inicio: "",
    descricao: ""
  });
}

export interface IAjuste {
  valido_de: Date;
  valido_ate: Date;
  ano: number;
  ciclo: number;
  nome: string
}

export function newIAjuste(): IAjuste {
  return ({
    nome: "",
    valido_de: null,
    valido_ate: null,
    ano: 0,
    ciclo: 0,
  });
}

export interface FilterContas {
  assinatura: string
  fatura: string
  conta: string
  filter: string
}

export function newFilterContas(): FilterContas {
  return ({
    assinatura: "",
    fatura: "",
    conta: "",
    filter: ""
  });
}

export interface INaoContestadosFilters {
    filterCest: string
    filterChave: string
    filterDescricao: string
    filterNcm: string
    filterItem: string
    filterNota: string
    filterOrigem: string
    filterDestino: string
}

export function newINaoContestadosFilters(): INaoContestadosFilters {
  return ({
    filterCest: "",
    filterChave: "",
    filterDescricao: "",
    filterNcm: "",
    filterItem: "",
    filterNota: "",
    filterOrigem: "",
    filterDestino: "",
  });
}